import { render } from "./large-checkbox.vue?vue&type=template&id=38c6550a&ts=true"
import script from "./large-checkbox.vue?vue&type=script&lang=ts"
export * from "./large-checkbox.vue?vue&type=script&lang=ts"

import "./large-checkbox.vue?vue&type=style&index=0&id=38c6550a&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1501305b0fb1954c01d0b4f35a9e823f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__